import { Roles } from '@assembly/pages/Teams/types'
import { RoutePaths } from './routes'

// Map of routes and which roles can access them
export const ROUTE_ACCESS_MAP: Record<string, Roles[]> = {
    [RoutePaths.OrganizationManager]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.Organization]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.Teams]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.Team]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.TeamMember]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.Resources]: [Roles.SuperAdmin, Roles.InternalAdmin, Roles.Recruiter],
    [RoutePaths.Resource]: [Roles.SuperAdmin, Roles.InternalAdmin, Roles.Recruiter],
    [RoutePaths.ResourcePayoutEntries]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.ResourcePayoutInvoices]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.TalentInvoices]: [Roles.SuperAdmin], // Only SuperAdmin can access
    [RoutePaths.ClientInvoices]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.ClientInvoice]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.Capabilities]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.AssemblyTemplates]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.AssemblyTemplate]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.AssemblyLines]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.AssemblyLine]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.Skills]: [Roles.SuperAdmin, Roles.InternalAdmin],
    [RoutePaths.SkillsAssessment]: [Roles.SuperAdmin, Roles.InternalAdmin, Roles.Recruiter],
    [RoutePaths.Candidates]: [Roles.SuperAdmin, Roles.InternalAdmin, Roles.Recruiter],
    [RoutePaths.Jobs]: [Roles.SuperAdmin, Roles.InternalAdmin, Roles.Recruiter],
    [RoutePaths.Debug]: [Roles.SuperAdmin, Roles.InternalAdmin, Roles.Recruiter]
}

// Helper function to check if a user role can access a specific route
export const canUserAccessRoute = (userRole: Roles, routePath: string): boolean => {
    // Handle dynamic routes by checking if the path starts with any of the mapped routes
    const matchedRoute = Object.keys(ROUTE_ACCESS_MAP).find(route => {
        // Handle exact matches first
        if (route === routePath) return true

        // Handle dynamic routes (e.g., /orgs/:id should match /orgs/123)
        const routePattern = route.replace(/:[^/]+/g, '[^/]+')
        const regex = new RegExp(`^${routePattern}$`)
        return regex.test(routePath)
    })

    if (!matchedRoute) {
        // If route is not in the map, default to requiring SuperAdmin access
        return userRole === Roles.SuperAdmin
    }

    return ROUTE_ACCESS_MAP[matchedRoute].includes(userRole)
}

// Helper function to get accessible navigation items for a role
export const getAccessibleNavItems = (userRole: Roles, navItems: any[]): any[] => {
    return navItems.filter(item => canUserAccessRoute(userRole, item.path))
} 